import type React from "react"
import { Modal, View, StyleSheet } from "react-native"
import { useTheme } from "react-native-paper"
import { NestedRowTableBase } from "./NestedRowTableBase"
import type { ColumnDefinition } from "../../types/project"

interface ExpandedNestedRowTableProps<T> {
    visible: boolean
    onDismiss: () => void
    data: T[]
    columns: ColumnDefinition[]
    levelKey: string
    childrenKey: string
    tableName: string
    defaultVisibleColumns?: string[]
    title?: string
}

export function ExpandedNestedRowTable<T extends Record<string, any>>({ 
    visible, 
    onDismiss, 
    ...tableProps 
}: ExpandedNestedRowTableProps<T>) {
    const theme = useTheme()

    return (
        <Modal visible={visible} onRequestClose={onDismiss} animationType="slide" presentationStyle="fullScreen">
            <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
                <NestedRowTableBase {...tableProps} />
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
})
